import React from "react";
import { OrderDetailBody } from "tsi-common-react/src/apps/customer-account/OrderDetailBody/index";

import { templates } from "@reactivated";

import { OrderDetail } from "../components/OrderDetail";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderDetailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OrderDetailBody {...props} OrderDetail={OrderDetail} />
    </PageSkeleton>
);
